export default __webpack_public_path__ + "71a1b5f1fd2800d7ee7c96a1533fc96f.png";